<ion-list lines="full">
  <ion-item [button]="true" (click)="navigate(['/property-search', 'owner'])" color="light">
    <ion-icon size="small" slot="start" src="/assets/svg/search-by-owner.svg"></ion-icon>
    <ion-label>Search By Owner</ion-label>
  </ion-item>
  <ion-item [button]="true" (click)="navigate(['/property-search', 'parcel-number'])" color="light">
    <ion-icon size="small" slot="start" src="/assets/svg/search-by-apn.svg"></ion-icon>
    <ion-label>Search by Parcel Number</ion-label>
  </ion-item>
  @if (useMobileLayout$ | async) {
    <ion-item [button]="true" (click)="navigateToCamera()" color="light">
      <ion-icon size="small" slot="start" src="/assets/svg/camera-view.svg"></ion-icon>
      <ion-label>Camera View</ion-label>
    </ion-item>
  }
  <ion-item [button]="true" (click)="navigate(['/property-search', 'advanced'])" color="light">
    <ion-icon size="small" slot="start" src="/assets/svg/advanced-search.svg"></ion-icon>
    <ion-label>Advanced Search</ion-label>
  </ion-item>
  <ion-item [button]="true" (click)="navigateToHistory()" color="light">
    <ion-icon size="small" slot="start" src="/assets/svg/profile-history.svg"></ion-icon>
    <ion-label>Profile History</ion-label>
  </ion-item>
</ion-list>
